// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

//= require rails-social-share-button
//= require('packs/social-share-button.js.erb')

import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "@fortawesome/fontawesome-free/css/all.css";
import "@splidejs/splide/dist/css/splide.min.css";

Rails.start()
ActiveStorage.start()

import "controllers"

require("trix")
require("@rails/actiontext")